export default {
  internal: 'INTERNAL',
  customer: 'CUSTOMER',
};
